import React from 'react';
import './component.css';
import styles from './Footer.module.css';
import { useIntl } from 'react-intl';

export const Footer = () => {
    const intl = useIntl();

    return (
        <>
            <div
                className={`text-white p-4 p-md-5 ${styles.footerContainer}`}
            >
                <div className="row align-items-end justify-content-between">
                    <div className="col-12 col-md-8 mb-4 mb-md-0">
                        <div className="mb-2">
                            {intl.formatMessage({ id: 'footer.copyright' })}
                        </div>
                        <div>
                            <a style={{color:"white"}} target="_blank" href="https://www.policlinicocampusbiomedico.it/privacy-policy-app-dea">
                                {intl.formatMessage({ id: 'footer.informativaPrivacy' })}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}